<script>
    export default {
        props: {
            item: {
                type: Object,
                required: true
            },
            moreInformationLabel: {
                type: String,
                default: 'Meer informatie'
            }
        }
    };
</script>

<template>
    <a :href="item.url" class="card is-clipped is-fullheight is-flex is-flex-direction-column">
        <div class="card-content is-flex is-align-items-center is-justify-content-space-between">
            <div class="is-flex-grow-1">
                <h2 v-if="item.title" class="title is-4 mb-3">{{ item.title }}</h2>
                
                <div v-if="item.soort || item.categorie || item.regio" class="tags are-medium mb-2">
                    <span v-if="item.soort" class="tag is-secondary is-size-9">
                        <span class="icon has-text-link"><i class="fa-solid fa-book-open"></i></span>
                        <span>{{ item.soort }}</span>
                    </span>
                    <span v-if="item.categorie" class="tag is-secondary is-size-9">
                        <span class="icon has-text-link"><i class="fa-solid fa-user"></i></span>
                        <span>{{ item.categorie }}</span>
                    </span>
                    <span v-if="item.regio" class="tag is-secondary is-size-9">
                        <span class="icon has-text-link"><i class="fa-solid fa-location-dot"></i></span>
                        <span>{{ item.regio }}</span>
                    </span>
                </div>

                <div v-if="item.datumEnTijden" v-html="item.datumEnTijden" class="content is-size-body has-text-weight-normal mb-3"></div>

                <div v-if="item.locatie && item.locatie.name" class="is-size-body has-text-weight-normal">
                    {{ item.locatie.name }}
                </div>

                <div class="is-hidden-desktop">
                    <span>{{ moreInformationLabel }}</span>
                    <span class="icon is-rounded has-background-primary ml-3">
                        <i class="fa-solid fa-arrow-right"></i>
                    </span>
                </div>
            </div>

            <span class="icon is-rounded has-background-primary is-hidden-touch is-flex-shrink-0">
                <i class="fa-solid fa-arrow-right"></i>
            </span>
        </div>
    </a>
</template>
